import { Link } from "react-router-dom";
import { API_URL } from "../../APIService";
import { useState } from "react";

function FormFile(props: any) {
  const downloadLink = API_URL + "file" + props.src.replace("/files/", "file/"); // make API download link according to endpoint
  const [src, setSrc] = useState(props.src);
  const onDelete = () => {
    if (props.onDelete()) setSrc("");
  };
  return (
    <div className="EditForm">
      <label className="EditLabel">{props.title}</label>
      <div className="EditInputHolder">
        {!props.readOnly ? (
          <input
            className="form-control"
            type="file"
            name={props.name}
            id={props.id}
            onChange={props.onChange}
          />
        ) : (
          <></>
        )}
        <div>
          <Link to={downloadLink} target="_blank">
            {src}
          </Link>
          {src && src.length > 0 && !props.readOnly ? (
            <span style={{ paddingLeft: "10px" }}>
              <button onClick={onDelete}>delete</button>
            </span>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

export default FormFile;
